<ng-template>
    <h3 class="overlay-header" mat-dialog-title>{{title}}</h3>
    <mat-dialog-content>
        <ng-content select="[content]"></ng-content>
    </mat-dialog-content>
    <mat-dialog-actions>
        <ng-content select="[buttons]"></ng-content>
        <button mat-button mat-dialog-close class="btn" [ngClass]="page == 'choosePlan' ? page : ''">{{closeBtnText}}</button>
    </mat-dialog-actions>
</ng-template>